export default __webpack_public_path__ + "static/media/Linktree.ee256184.svg";